import { Box, IconButton, Tooltip, Typography, styled } from '@mui/material'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import '../../styles/sass/ButtonLike.scss'
import { StyledFavoriteButton } from '../../styles/DetailPanelStyle'

const HeartButton = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    backgroundColor: 'rgb(0 0 0 / 0%) !important'
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: 32
  }
}))

type FavoriteButtonProps = {
  favoriteState: boolean
  handleClick: (state: boolean) => void
  type?: 'icon' | 'button'
}

function FavoriteButton({ favoriteState, handleClick, type = 'icon' }: FavoriteButtonProps) {
  const { t } = useTranslation(['global'])

  const [state, setState] = useState<boolean>(favoriteState)
  const [isAnimating, setIsAnimating] = useState<boolean>(false)

  useEffect(() => {
    if (isAnimating) {
      const animationTimeout = setTimeout(() => {
        setIsAnimating(false)
      }, 800)
      return () => clearTimeout(animationTimeout)
    }
  }, [isAnimating])

  useEffect(() => {
    setState(favoriteState)
  }, [favoriteState])

  const onHandleClick = () => {
    if (state) {
      handleClick(false)
    } else {
      setIsAnimating(true)
      handleClick(true)
    }
    setState(!state)
  }

  return (
    <Tooltip title="Me gusta" className="heartContainer">
      <>
        {type === 'icon' && (
          <Tooltip title={state ? `${t('remove-from-favorites')}` : `${t('add-to-favorites')}`} placement="bottom">
            <HeartButton
              className={clsx(isAnimating && 'is_animating')}
              disableRipple
              disableTouchRipple
              disableFocusRipple
              onClick={onHandleClick}
            >
              <Box className={clsx('heartAbsolute', state && 'is_active', isAnimating && 'is_animating')} />
            </HeartButton>
          </Tooltip>
        )}

        {type === 'button' && (
          <StyledFavoriteButton variant="outlined" className={clsx('redOut', isAnimating && 'is_animating')} onClick={onHandleClick}>
            <Box className={clsx('heart', state && 'is_active', isAnimating && 'is_animating')} />
            <Typography variant="body2">{state ? `${t('remove-from-favorites')}` : `${t('add-to-favorites')}`}</Typography>
          </StyledFavoriteButton>
        )}
      </>
    </Tooltip>
  )
}

export default FavoriteButton
